export default "__VITE_ASSET__CinGzJjs__"